// components/HowItWorks.js
import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    { number: 1, title: "Targeted Ads", desc: "We run paid ads on Meta, Google, and partner platforms" },
    { number: 2, title: "Form Submission", desc: "Customers fill multi-step industry-specific forms" },
    { number: 3, title: "OTP Verification", desc: "Phone number is OTP verified" },
    { number: 4, title: "Manual Calling", desc: "Team manually calls and records user intent" },
    { number: 5, title: "AI Filtering", desc: "Leads are AI filtered based on your criteria" },
    { number: 6, title: "Human Check", desc: "Agents re-check for match, quality, and interest" },
    { number: 7, title: "Instant Delivery", desc: "Leads sent via WhatsApp & Google Sheets" }
  ];

  return (
    <section id="how-it-works" className="how-section fade-in-section">
      <div className="container">
        <h2 className="section-title">How LeadVala Works</h2>
        <p className="section-subtitle">Our 7-Layer AI + Human verification system</p>
        
        <div className="process-flow">
          {steps.map((step, index) => (
            <React.Fragment key={step.number}>
              <div className="process-step">
                <div className="step-number">{step.number}</div>
                <h4>{step.title}</h4>
                <p>{step.desc}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="process-arrow">→</div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;